import type { FieldDefinition, MapDefinition } from '@grs-atlas/shared';
import { US_STATE_CODES, US_STATE_NAMES } from '@grs-atlas/shared';

interface FilterBarProps {
  map: MapDefinition;
  values: Record<string, string>;
  onChange: (next: Record<string, string>) => void;
}

export function FilterBar({ map, values, onChange }: FilterBarProps) {
  const filterFields = map.filters
    .map((key) => map.fields.find((f) => f.key === key))
    .filter((f): f is FieldDefinition => !!f);

  const set = (key: string, value: string) => {
    const next = { ...values };
    if (!value) delete next[key];
    else next[key] = value;
    onChange(next);
  };

  return (
    <div className="filters" role="search" aria-label="Map filters">
      <label>
        Search
        <input
          type="search"
          value={values.search ?? ''}
          onChange={(e) => set('search', e.target.value)}
          placeholder="Search records"
        />
      </label>
      <label>
        State
        <select
          value={values.state ?? ''}
          onChange={(e) => set('state', e.target.value)}
        >
          <option value="">All states</option>
          {US_STATE_CODES.map((code) => (
            <option key={code} value={code}>
              {US_STATE_NAMES[code]} ({code})
            </option>
          ))}
        </select>
      </label>
      {filterFields.map((field) => {
        if (field.type === 'select' || field.type === 'status' || field.type === 'confidence') {
          return (
            <label key={field.key}>
              {field.label}
              <select
                value={values[field.key] ?? ''}
                onChange={(e) => set(field.key, e.target.value)}
              >
                <option value="">All</option>
                {(field.options ?? []).map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </label>
          );
        }
        if (field.type === 'boolean') {
          return (
            <label key={field.key}>
              {field.label}
              <select
                value={values[field.key] ?? ''}
                onChange={(e) => set(field.key, e.target.value)}
              >
                <option value="">All</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </label>
          );
        }
        return (
          <label key={field.key}>
            {field.label}
            <input
              value={values[field.key] ?? ''}
              onChange={(e) => set(field.key, e.target.value)}
            />
          </label>
        );
      })}
      <div style={{ alignSelf: 'end' }}>
        <button
          type="button"
          className="btn secondary"
          onClick={() => onChange({})}
        >
          Clear Filters
        </button>
      </div>
    </div>
  );
}
